/**
 * Created by Timur on 27.07.2026
 */

const BalloonRiseFinishWindow = Prefab.createWindow("balloon_rise", "balloon_rise_finish_window_prefab_json");
